import * as React from "react"
import { cn } from "@/lib/utils"

const Avatar = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full bg-muted text-sm font-medium text-foreground",
      className
    )}
    {...props}
  >
    <span className="m-auto">{children}</span>
  </div>
))
Avatar.displayName = "Avatar"

const AvatarImage = React.forwardRef(({ className, alt, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/alt-text
  <img
    ref={ref}
    className={cn("aspect-square h-full w-full", className)}
    alt={alt}
    {...props}
  />
))
AvatarImage.displayName = "AvatarImage"

const AvatarFallback = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex h-full w-full items-center justify-center bg-transparent text-current text-xs font-semibold uppercase",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
)
AvatarFallback.displayName = "AvatarFallback"

export { Avatar, AvatarImage, AvatarFallback }

